var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 72,
    viewBox: "0 0 200 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 200,
    height: 3,
    rx: 1.5,
    fill: "#212121",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.762 17.172L100.419 1.01658C99.0437 -0.343656 96.8153 -0.337314 95.4466 1.0264L79.2389 17.172C75.4819 20.9429 81.118 26.5995 84.8758 22.8285L91.8953 15.7847C93.0658 14.61 94.0152 15.0062 94.0152 16.6566V45.9981C94.0152 48.208 95.7988 49.9978 98.001 49.9978C100.202 49.9978 101.987 48.208 101.987 45.9981V16.6566C101.987 14.9999 102.93 14.6044 104.106 15.7847L111.125 22.8285C114.882 26.5995 120.519 20.9429 116.762 17.172Z",
    fill: "#212121",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.29cb038516ea871bc5f0b0d647c55fb6.svg";
export { ForwardRef as ReactComponent };